import { jsx as _jsx } from "react/jsx-runtime";
import Loading from 'components/Loading';
import DashboardPage from 'screens/DashboardScreen/components/DashboardPage';
import { txt } from 'libs/i18n';
import { Flex } from 'antd';
const LoadingPage = ({ message }) => (_jsx(DashboardPage, { title: message !== null && message !== void 0 ? message : txt('loading'), children: _jsx(Flex, { justify: "center", children: _jsx(Loading, { message: message !== null && message !== void 0 ? message : txt('loading') }) }) }));
export default LoadingPage;
